/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'support';
const componentName = 'tech-support-generation-service';
const prefix = `${moduleName}.${componentName}`;

export const modalNameLabel = `${prefix}.modalNameLabel`;
export const debugLogsLabel = `${prefix}.debugLogsLabel`;
export const clusteringLabel = `${prefix}.clusteringLabel`;
export const gslbLabel = `${prefix}.gslbLabel`;
export const metricsLogsLabel = `${prefix}.metricsLogsLabel`;
export const placementLabel = `${prefix}.placementLabel`;
export const portalLabel = `${prefix}.portalLabel`;
export const virtualServiceLabel = `${prefix}.virtualServiceLabel`;
export const collectionCompleteLabel = `${prefix}.collectionCompleteLabel`;
export const techSupportLabel = `${prefix}.techSupportLabel`;
export const poolLabel = `${prefix}.poolLabel`;
export const serviceEngineLabel = `${prefix}.serviceEngineLabel`;
export const upgradeLabel = `${prefix}.upgradeLabel`;

export const ENGLISH = {
    [modalNameLabel]: 'Tech Support',
    [debugLogsLabel]: 'Debug Logs {0}',
    [clusteringLabel]: 'Clustering {0}',
    [gslbLabel]: 'GSLB {0}',
    [metricsLogsLabel]: 'Metrics Logs {0}',
    [placementLabel]: 'Placement {0}',
    [portalLabel]: 'Portal {0}',
    [virtualServiceLabel]: 'Virtual Service {0}',
    [collectionCompleteLabel]: 'Collection Complete',
    [techSupportLabel]: 'Tech Support {0}',
    [poolLabel]: 'Pool {0}',
    [serviceEngineLabel]: 'Service Engine {0}',
    [upgradeLabel]: 'Upgrade {0}',
};
